import * as React from 'react'

import { PiEye, PiEyeSlash } from 'react-icons/pi'

import Input, { type InputProps } from './Input'

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'rightIcon'> {
  showToggle?: boolean
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ showToggle = true, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const rightIcon = showToggle ? (
    <button
      type="button"
      onClick={togglePasswordVisibility}
      className="text-th-text-secondary transition-colors hover:text-th-text"
      title={showPassword ? 'Hide text' : 'Show text'}
      aria-label={showPassword ? 'Hide text' : 'Show text'}
      aria-pressed={showPassword}
    >
      {showPassword ? <PiEyeSlash className="h-5 w-5" /> : <PiEye className="h-5 w-5" />}
    </button>
  ) : undefined

  return <Input {...props} ref={ref} type={showPassword ? 'text' : 'password'} rightIcon={rightIcon} />
})

PasswordInput.displayName = 'PasswordInput'

export default PasswordInput
